import React, {useEffect, useState} from "react";
import {Button, Card, Input, Form, Select, Col, Row} from "antd";
import {getTaskActions, getTaskLinks, getUserRoles} from "../../../api";
import TextArea from "antd/es/input/TextArea";
import TaskSymbols from "./TaskSymbols";
import MultiselectExtension from "../../MultiselectExtension";
import Icon, {FilterOutlined} from "@ant-design/icons"

function AddEditRevisionForm ({ action, task, onClose, taskRevisions, revisionStatus, taskGroup, resetRevisionTasks, baseTasks, setSaveDisable,
                                  taskTypes, setTableTasks, setDefTypeId}) {
    const [form] = Form.useForm();
    const [taskTypeId, setTaskTypeId] = useState(task?.taskTypeId);
    const [taskSerialNo, setTaskSerialNo] = useState(task ? task?.taskSerialNo:0);
    const [taskDesc, setTaskDesc] = useState(task?.taskDesc);
    const [symbolId, setSymbolId] = useState(task?.fileId);
    const [selectedRoles, setSelectedRoles] = useState(task?.taskRoles);
    const [selectedLinks, setSelectedLinks] = useState(task?.taskLinks);
    const [selectedActions, setSelectedActions] = useState(task?.taskActions);
    const [taskRoles,setTaskRoles] = useState([]);
    const [taskLinks,setTaskLinks] = useState([]);
    const [filteredLinks, setFilteredLinks] = useState([]);
    const [linkValue, setLinkValue] = useState(null);
    const [taskActions,setTaskActions] = useState([]);
    const [maxCnt, setMaxCnt] = useState(0);

    useEffect(() => {
        async function getData() {
            let tasks = await getUserRoles();
            setTaskRoles(tasks.data.filter(t=>t.assignTasksFl==='Y'));
            let links = await getTaskLinks();
            let newlinks = links.data.filter(t=>t.disableFlag==='N').map((t)=>
            {
                return {...t, linkDisplay:t.linkTitle+(t.docTitle?('-'+t.docTitle):'')};
            });
            setTaskLinks(newlinks);
            setFilteredLinks(newlinks);
            if(taskGroup === 'AT') {
                let actions = await getTaskActions();
                setTaskActions(actions.data);
            }
        }
        getData();
        let cnt = taskRevisions.filter((t)=>{
            if(t.taskTypeId===task?.taskTypeId)
                return t;
        }).length;
        setMaxCnt(cnt);
        if(action === 'Add') {
            setMaxCnt(cnt + 1);
            setTaskSerialNo(cnt+1);
        }
    }, []);

    const onTypeChange = (value) => {
        if (value !== null || value !== '') {
            setTaskTypeId(value);
            let cnt = taskRevisions.filter((t)=>{
                if(t.taskTypeId===value)
                    return t;
            }).length;
            setMaxCnt(cnt);
            if(action === 'Add') {
                setMaxCnt(cnt + 1);
                setTaskSerialNo(cnt+1);
            }
        }
        form.setFieldsValue({
            'taskType': value
        });
    }
    const onTaskNoChange = (value) => {
        if (value !== null || value !== '') {
            setTaskSerialNo(value);
        }
        form.setFieldsValue({
            'taskNo': value
        });
    }
    const onDescChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setTaskDesc(value);
            form.setFieldsValue({
                'taskDesc': value
            });
        }
    }
    const onSymbolChange = (value) => {
        if (value !== null || value !== '') {
            setSymbolId(value);
            form.setFieldsValue({
                'taskSymbol': value
            });
        }
    }
    function handleActionChange(optionsList, selectedItem) {
        setSelectedActions(optionsList);
    }
    const resetActions = () => {
        //teamMemberRef.current.resetSelectedValues();
        handleActionChange([]);
    };
    function handleRoleChange(optionsList, selectedItem) {
        setSelectedRoles(optionsList);
    }
    const resetRoles = () => {
        //teamMemberRef.current.resetSelectedValues();
        handleRoleChange([]);
    };
    function handleLinkChange(optionsList, selectedItem) {
        setSelectedLinks(optionsList);
    }
    const resetLinks = () => {
        //teamMemberRef.current.resetSelectedValues();
        handleLinkChange([]);
    };
    const onLinkValueChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setLinkValue(value);
        }
    }
    function onLinkFilterChange()
    {
        //let value = e.target.value;
        if(linkValue === '' || linkValue == null)
        {
            setFilteredLinks(taskLinks);
            return;
        }
        let newlist = taskLinks.filter(t=>(t.docId && t.docId.toUpperCase().indexOf(linkValue.toUpperCase())>=0)
            ||(t.linkTitle && t.linkTitle.toUpperCase().indexOf(linkValue.toUpperCase())>=0));
        setFilteredLinks(newlist);
    }
    const onSubmit = (values) => {
        if(action==='Add') {
            let arr = [...taskRevisions,
                {...task, taskTypeId: taskTypeId,taskSerialNo: taskSerialNo, taskDesc: taskDesc, fileId: symbolId, editFlag: 'A',
                    taskRoles: selectedRoles, taskLinks:selectedLinks, taskActions: selectedActions}];
            let newTasks = resetRevisionTasks(arr, baseTasks);
            setTableTasks(newTasks.filter(k => k.taskTypeId===taskTypeId).sort(function(a,b){return a.taskSerialNo-b.taskSerialNo}));
            setDefTypeId(taskTypeId);
        }
        else
        {
            let updatedTask = {...task, taskSerialNo: taskSerialNo, taskDesc: taskDesc, fileId: symbolId, editFlag:'E',
            taskRoles: selectedRoles, taskLinks:selectedLinks, taskActions: selectedActions};
            let arr = [];
            for(let index=0; index<taskRevisions.length; ++index)
            {
                if(taskRevisions[index].pos !== task.pos)
                    arr.push(taskRevisions[index]);
            }
            arr.push(updatedTask);
            let newTasks = resetRevisionTasks(arr, baseTasks);
            setTableTasks(newTasks.filter(k => k.taskTypeId===task.taskTypeId).sort(function(a,b){return a.taskSerialNo-b.taskSerialNo}));
        }
        setSaveDisable(false);
        onClose();
    };

    function optionList()
    {
        let rows = [];
        for(let i=1;i<=maxCnt;++i)
        {
            rows.push(<Select.Option
                key={'serialNo'+i}
            value={i}
            >{i}
            </Select.Option>);
        }
        return rows;
    }
    return (
        <div className='react-confirm-alert-body'>
            <h4>{action=='Add' ? 'Add New Task':'Editing Task #'+task?.taskMasterId}</h4>
            {revisionStatus==='A' && <p style={{color:'red'}}>Warning: Changing Active Revision will affect existing Tasks display.</p>}
            <section>
            <Form
                form={form}
                style={{ padding: '1rem 1rem' }}
                onFinish={(values) => onSubmit(values)}
            >
                <div style={{ top: 15, position: 'relative' }}>
                    <Row justify='center' align='middle'>
                        <Col sm={24} style={{ alignItems: 'end' }}>
                            <Form.Item
                                label='Task Type:'
                                name='taskType'
                                initialValue={taskTypeId}
                                labelCol={{ span: 5 }}
                                style={{fontWeight:'bolder'}}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select Task Type'
                                    }
                                    ]}
                            >
                                <Col>
                                    <Select
                                        size='small'
                                        value={taskTypeId}
                                        disabled={action==='Edit'}
                                         placeholder='Search Task Type'
                                        onSelect={(value) => onTypeChange(value)}
                                        onChange={(value) => onTypeChange(value)}
                                    >
                                        {taskTypes.map((type, index) => (
                                            <Select.Option
                                                id={'taskType-'+type.typeId}
                                                key={type.typeId}
                                                value={type.typeId}
                                            >{type.taskType}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={24} style={{ alignItems: 'end' }}>
                            <Form.Item
                                label='Task No:'
                                name='taskNo'
                                initialValue={taskSerialNo}
                                labelCol={{ span: 5 }}
                                style={{fontWeight:'bolder'}}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter number!',
                                    }
                                    ]}
                            >
                                <Col>
                                    <Select
                                        size='small'
                                        value={taskSerialNo}
                                        disabled={true}
                                        placeholder='Search Task Type'
                                        onSelect={(value) => onTaskNoChange(value)}
                                        onChange={(value) => onTaskNoChange(value)}
                                    >
                                        {optionList()}
                                    </Select>
                                </Col>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={24} style={{ alignItems: 'end' }}>
                            <Form.Item
                                label='Task Desc'
                                name='taskDesc'
                                initialValue={taskDesc}
                                labelCol={{ span: 5 }}
                                style={{fontWeight:'bolder'}}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter description!'
                                    }                                ]}
                            >
                                <Col>
                                    <TextArea
                                        size='small'
                                        value={taskDesc}
                                        autoSize={true}
                                        placeholder='Task Description'
                                        onChange={(value) => onDescChange(value)}
                                    />
                                </Col>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={24} style={{ alignItems: 'end' }}>
                            <Form.Item
                                label='Task Symbol'
                                name='taskSymbol'
                                initialValue={symbolId}
                                labelCol={{ span: 5 }}
                                style={{fontWeight:'bolder'}}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select symbol!'
                                    }                                ]}
                            >
                                <Col>
                                    <Select
                                        size='small'
                                        value={symbolId}
                                        placeholder='Select Task Symbol'
                                        onSelect={(value)=>onSymbolChange(value)}
                                        onChange={(value)=>onSymbolChange(value)}
                                    >
                                        {TaskSymbols.map((sy, index) => (
                                            <Select.Option
                                                id={'taskSymbol-'+sy.fileId}
                                                key={sy.fileId}
                                                value={sy.fileId}
                                            >{sy.desc}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            </Form.Item>
                        </Col>
                    </Row>
                    { taskGroup==='AT' &&
                    <Row>
                        <Col sm={24} style={{ alignItems: 'end' }}>
                            <Form.Item
                                label='Task Actions'
                                name='taskAction'
                                initialValue={symbolId}
                                labelCol={{ span: 5 }}
                                style={{fontWeight:'bolder'}}
                            >
                                <Col>
                                    <MultiselectExtension options={taskActions}
                                                          selectedValues={selectedActions}
                                                          onSelect={handleActionChange}
                                                          onRemove={handleActionChange}
                                                          showCheckbox={true}
                                                          displayValue="actionCode"
                                                          placeholder="Select or Remove Actions"
                                                          resetSelectField={resetActions}
                                    />
                                </Col>
                            </Form.Item>
                        </Col>
                    </Row>
                    }
                    <Row>
                        <Col sm={24} style={{ alignItems: 'end' }}>
                            <Form.Item
                                label='Task Roles'
                                name='taskRoles'
                                initialValue={selectedRoles}
                                labelCol={{ span: 5 }}
                                style={{fontWeight:'bolder'}}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select Roles',
                                        validator: ()=>{
                                            if(selectedRoles.length>0)
                                                return Promise.resolve();
                                            else
                                                return Promise.reject('Roles required');
                                        }
                                    }
                                ]}
                            >
                                <Col>
                                    <MultiselectExtension options={taskRoles}
                                                          selectedValues={selectedRoles}
                                                          onSelect={handleRoleChange}
                                                          onRemove={handleRoleChange}
                                                          showCheckbox={true}
                                                          displayValue="roleName"
                                                          placeholder="Select or Remove Roles"
                                        //ref={teamMemberRef}
                                                          resetSelectField={resetRoles}
                                    />
                                </Col>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={24} style={{ alignItems: 'end' }}>
                            <Form.Item
                                label='Task Links'
                                name='taskLinks'
                                initialValue={filteredLinks}
                                labelCol={{ span: 5 }}
                                style={{fontWeight:'bolder'}}
                            >
                                <Col>
                                    <Input style={{width:'500px',height:'40px'}}
                                        onChange={(value) => onLinkValueChange(value)}
                                        //onSearch={onLinkFilterChange}
                                        placeholder="Filter Links based on Link Title or Doc. Id"
                                    />
                                    <Button style={{height:'40px'}} onClick={onLinkFilterChange}><Icon component={FilterOutlined}/></Button>
                                    <MultiselectExtension options={filteredLinks}
                                                          selectedValues={selectedLinks}
                                        onSelect={handleLinkChange}
                                        onRemove={handleLinkChange}
                                                          showCheckbox={true}
                                                          displayValue="linkTitle"
                                                          placeholder="Select or Remove Links"
                                         resetSelectField={resetLinks}
                                    />
                                </Col>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                <div className='btn start-2'>
                    <Button
                        className='btn btn-primary start-5'
                        type='primary' htmlType='submit'
                    >
                        Apply Changes
                    </Button>
                    <Button className='btn btn-primary start-5' type='primary' onClick={onClose}>
                        Cancel
                    </Button>{' '}
                </div>
            </Form>
            </section>
        </div>
  );
}

export default AddEditRevisionForm;